import { useEffect } from "react";
import { useSelector } from "react-redux";

import {
  selectCompanyId,
  selectActiveCompanyId,
} from "@shared/api/reduxToolkit";

import { useActions } from "./useActions";

export const useCompanyInitializer = () => {
  const { initializeCompanyContext } = useActions();
  const userCompanyId = useSelector(selectCompanyId);
  const activeCompanyId = useSelector(selectActiveCompanyId);

  useEffect(() => {
    if (userCompanyId && !activeCompanyId) {
      initializeCompanyContext(userCompanyId);
    }
  }, [userCompanyId, activeCompanyId, initializeCompanyContext]);
};
